import { render, staticRenderFns } from "./DxpPageHeader.vue?vue&type=template&id=69b46296&scoped=true&"
import script from "./DxpPageHeader.vue?vue&type=script&lang=js&"
export * from "./DxpPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./DxpPageHeader.vue?vue&type=style&index=0&id=69b46296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b46296",
  null
  
)

export default component.exports